export default __webpack_public_path__ + "static/media/Project1.bf3286f5.png";